import DescriptionsLabel from './descriptions-label';

export default DescriptionsLabel;
